import { ProjectListContainer } from 'views';

export const BoardViews = {
  status: ProjectListContainer
};
